import React from 'react'
import noimg from "../Images/noimg.jpg"


function Profile_Tour_commision() {
  const customer = JSON.parse(localStorage.getItem("customer"));
  console.log("customer", customer);

  return (
    <div className='Profile_Tour_commision'>
      <div style={{ display: "flex", justifyContent: "space-between", maxWidth: "900px", margin: "auto" }}>
        <span style={{ fontWeight: "700", color: "green" }}>Approved Commission : </span>
        <span style={{ fontWeight: "700", color: "green" }}>{customer?.tour_commission || 0}%</span>
      </div>

      <div style={{marginTop:"3rem"}}>
      <div className="commission-card" style={{marginTop:"1rem"}}>
        {/* LEFT IMAGE */}
        <div className="commission-card-img">
          <img
            src={noimg}
            alt="Tour"
          />
        </div>

        {/* CENTER DETAILS */}
        <div className="commission-card-details">
          <h4 className="commission-title">Tour Name</h4>
          <p className="commission-text">
            <strong>Type:</strong> Tour
          </p>
          <p className="commission-text">
            <strong>Booking Date:</strong> 25/01/2026
          </p>
        </div>

        {/* RIGHT INFO */}
        <div className="commission-card-meta">
          <p className="commission-amount"> Amount: ₹ 2500</p>
          <span className="commission-status pending">Pending</span>
          <p className="commission-date">25/01/2026</p>
        </div>
      </div>
      <div className="commission-card" style={{marginTop:"1rem"}}>
        {/* LEFT IMAGE */}
        <div className="commission-card-img">
          <img
            src={noimg}
            alt="Tour"
          />
        </div>

        {/* CENTER DETAILS */}
        <div className="commission-card-details">
          <h4 className="commission-title">Tour Name</h4>
          <p className="commission-text">
            <strong>Type:</strong> Tour
          </p>
          <p className="commission-text">
            <strong>Booking Date:</strong> 25/01/2026
          </p>
        </div>

        {/* RIGHT INFO */}
        <div className="commission-card-meta">
          <p className="commission-amount"> Amount: ₹ 2500</p>
          <span className="commission-status pending">Pending</span>
          <p className="commission-date">25/01/2026</p>
        </div>
      </div>
      <div className="commission-card" style={{marginTop:"1rem"}}>
        {/* LEFT IMAGE */}
        <div className="commission-card-img">
          <img
            src={noimg}
            alt="Tour"
          />
        </div>

        {/* CENTER DETAILS */}
        <div className="commission-card-details">
          <h4 className="commission-title">Tour Name</h4>
          <p className="commission-text">
            <strong>Type:</strong> Tour
          </p>
          <p className="commission-text">
            <strong>Booking Date:</strong> 25/01/2026
          </p>
        </div>

        {/* RIGHT INFO */}
        <div className="commission-card-meta">
          <p className="commission-amount"> Amount: ₹ 2500</p>
          <span className="commission-status paid">Paid</span>
          <p className="commission-date">25/01/2026</p>
        </div>
      </div>
      <div className="commission-card" style={{marginTop:"1rem"}}>
        {/* LEFT IMAGE */}
        <div className="commission-card-img">
          <img
            src={noimg}
            alt="Tour"
          />
        </div>

        {/* CENTER DETAILS */}
        <div className="commission-card-details">
          <h4 className="commission-title">Tour Name</h4>
          <p className="commission-text">
            <strong>Type:</strong> Tour
          </p>
          <p className="commission-text">
            <strong>Booking Date:</strong> 25/01/2026
          </p>
        </div>

        {/* RIGHT INFO */}
        <div className="commission-card-meta">
          <p className="commission-amount"> Amount: ₹ 2500</p>
          <span className="commission-status pending">Pending</span>
          <p className="commission-date">25/01/2026</p>
        </div>
      </div>
      </div>


    </div>
  )
}

export default Profile_Tour_commision